import React from 'react';
import { useAppTranslation } from '@/i18n/useAppTranslation';

/**
 * Danh sách từng câu sau khi chấm — dùng chung cho màn kết quả ngay sau nộp bài và lịch sử.
 * `question_results` khớp cấu trúc API worker (question_text, user_answer_display, correct_answer_display, explanation, …).
 */
export default function QuizResultQuestionBreakdown({ questionResults, className = '' }) {
  const { t } = useAppTranslation();
  const qr = Array.isArray(questionResults) ? questionResults : [];
  if (qr.length === 0) return null;
  const normalizeAnswerDisplay = (value) => {
    const v = String(value ?? '').trim();
    if (!v) return t('quizResult.notSelected');
    if (/^\(?\s*(không chọn|khong chon|not selected|未选择)\s*\)?$/i.test(v)) return t('quizResult.notSelected');
    return value;
  };

  return (
    <div className={`space-y-3 ${className}`.trim()}>
      {qr.map((row) => (
        <article
          key={row.question_id}
          className={`rounded-2xl border p-5 ${
            row.is_correct ? 'border-[#6cf8bb] bg-[#6cf8bb]/20' : 'border-[#ffdad6] bg-[#ffecea]'
          }`}
        >
          <p className="text-xl font-extrabold text-[#191b23] md:text-2xl">
            {t('quizResult.questionOrder', { order: row.question_order })}{' '}
            <span className={row.is_correct ? 'text-[#006c49]' : 'text-[#ab0b1c]'}>
              {row.is_correct ? t('quizResult.correct') : t('quizResult.incorrect')}
            </span>
          </p>
          <p className="mt-2 text-base font-semibold text-[#191b23] md:text-lg">{row.question_text}</p>
          <p className="mt-3 text-base text-[#434655] md:text-lg">
            {t('quizResult.yourPick', { answer: normalizeAnswerDisplay(row.user_answer_display) })}
          </p>
          <p className="text-base font-bold text-[#003ea8] md:text-lg">
            {t('quizResult.answerKey', { answer: normalizeAnswerDisplay(row.correct_answer_display) })}
          </p>
          {row.explanation ? (
            <p className="mt-3 rounded-xl border border-[#c3c6d7]/50 bg-[#f3f3fe] p-3 text-sm leading-relaxed text-[#434655] md:text-base">
              <span className="font-bold text-[#004ac6]">{t('quizResult.explanationLead')} </span>
              {row.explanation}
            </p>
          ) : null}
        </article>
      ))}
    </div>
  );
}
